exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree-node.selected{background:rgba(117,179,37,.2);color:#fff}.children-nodes{padding-left:15px}.tree-node .node-title{height:20px;display:flex;flex-flow:row;flex-wrap:nowrap;align-items:center;padding-left:0;flex-shrink:0;font-size:12px}.tree-node .node-title.locked{color:#999}.tree-node .node-icon{width:20px;height:20px;display:flex;align-items:center;flex-shrink:0;justify-content:center}.tree-node .node-title:hover{background:hsla(0,0%,100%,.05)}.node-context-menu{position:fixed;display:flex;flex-flow:column;min-width:80px;background:#fff;color:#000;box-shadow:1px 0 5px 0 rgba(0,0,0,.5)}.node-context-menu .menu-item{flex:1;padding:10px;border-bottom:1px solid #ebebeb}.node-context-menu .menu-item i{color:#75b325;width:20px}.node-context-menu .menu-item:hover{background:#ebebeb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b4575f6c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/treebox/TreeNode.vue
// module id = 323
// module chunks = 0